import { Component, OnDestroy, OnInit } from '@angular/core';
import { GetExercisesResponseDTO } from '../doggyhub/doggyhub.dto';
import { Subscription } from 'rxjs';
import { DoggyhubService } from '../doggyhub/doggyhub.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Share } from '@capacitor/share';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Clipboard } from '@capacitor/clipboard';
import { ToastController } from '@ionic/angular';
@Component({
  selector: 'app-exercise',
  templateUrl: './exercise.page.html',
  styleUrls: ['./exercise.page.scss'],
})
export class ExercisePage implements OnInit, OnDestroy {
  isLoading = true;
  exercise: GetExercisesResponseDTO;
  exerciseSub: Subscription;
  url: string;
  trustedLink: SafeResourceUrl;
  newDirections: string;
  constructor(
    private doggyhubService: DoggyhubService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private domSanitizer: DomSanitizer,
    private toastController: ToastController
  ) { }

  ngOnInit() {
    const exerciseId = +this.activatedRoute.snapshot.params.id;
    this.exerciseSub = this.doggyhubService
      .getExerciseById(exerciseId)
      .subscribe((res) => {
        this.exercise = res;
        this.url = environment.appUrl + this.router.url;
        this.trustedLink = this.domSanitizer.bypassSecurityTrustResourceUrl(
          this.exercise.videoUrl
        );
        const lines = this.exercise.description.split('\n');
        while (lines.length && lines[lines.length - 1].trim() === "") {
          lines.pop();
        }
        // Separate last 2 lines (emoji lines)
        const emojiLines = lines.slice(-2);
        const normalLines = lines.slice(0, -2);

        const formatted = normalLines.map(line => {
          const match = line.match(/^(\d+)-\s*(.*)/);
          if (match) {
            const stepNumber = match[1];
            const stepBody = match[2];

            const [title, ...rest] = stepBody.split("–");
            const stepTitle = title.trim();
            const description = rest.join("–").trim();

            if (description) {
              return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle} – ${description}</div>`;
            } else {
              return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle}</div>`;
            }
          } else {
            return `<div class="instruction-line">${line}</div>`;
          }
        });

        // Add emoji block with both lines wrapped in instruction-line divs
        const emojiBlock = `
  <div class="emoji">
    ${emojiLines.map(l => `<div class="emoji-line">${l}</div>`).join('')}
  </div>
`;

        formatted.push(emojiBlock);

        this.newDirections = formatted.join('\n');
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    if (this.exerciseSub) this.exerciseSub.unsubscribe();
  }

  async shareArticle() {
    await Share.share({
      title: 'Check this out',
      text: `Your fur baby will love this exercise!! ${this.url}`, // Combine text and URL
    });
  }

  async copyLink() {
    try {
      await Clipboard.write({
        string: this.url,
      });

      const toast = await this.toastController.create({
        message: 'URL copied to clipboard!',
        color: 'primary',
        duration: 2000,
        position: 'bottom',
      });
      toast.present();
    } catch (error) {
      console.error('Failed to copy URL:', error);
      const toast = await this.toastController.create({
        message: 'Failed to copy URL.',
        duration: 2000,
        position: 'bottom',
      });
      toast.present();
    }
  }
}
